export default{scrim:"w_GR"};
